import { takeLatest, put, select } from 'redux-saga/effects';
import { createNewPortfolioSaga } from '@components/CreatePortfolio/redux/sagas';
import { getUserCurrency } from '@user/redux/selectors';
import { v4 as uuidv4 } from 'uuid';

import { fetchDashboardMyMarketsAndIndustries } from './routines';
import { fetchPortfolioList } from '@/components/DeprecatedPortfolio/redux/routines';
import { updateUserProfile } from '@user/redux/routines';
import { getPortfolioList } from '@/components/DeprecatedPortfolio/redux/selectors';
import { getDefaultPortfolioId } from '@user/redux/selectors';
import { getCurrentLocation } from '@ducks/location/selectors';
import type { LocationState } from 'redux-first-router';
import { getDashboardMyMarketsAndIndustries as getDashboardMyMarketsAndIndustriesService } from '@simplywallst/services';
import type { Response as MyMarketsAndIndustriesResponse } from '@simplywallst/services/lib/endpoints/getDashboardMyMarketsAndIndustries';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { addSnackBar, removeSnackBar } from '@components/SnackBar/redux';

import { getAuthenticatedAhoy } from '@ducks/saga';

function* setDefaultPortfolioIdWorker() {
  try {
    const location: LocationState = yield select(getCurrentLocation);
    if (location.type === ROUTE_DASHBOARD) {
      const defaultPortfolioId: string = yield select(getDefaultPortfolioId);
      const portfolioList = yield select(getPortfolioList);

      if (
        defaultPortfolioId === '' ||
        typeof portfolioList[defaultPortfolioId] === 'undefined'
      ) {
        const [firstKey] = Object.keys(portfolioList);
        let id = firstKey;

        if (!id) {
          // NO ID, CREATE PORTFOLIO
          const snackBarId = uuidv4();
          const userCurrency = yield select(getUserCurrency);
          const defaultPortfolioName = 'My Portfolio';
          yield put(
            addSnackBar.trigger({
              id: snackBarId,
              message: 'Creating portfolio',
              isLoading: true,
            })
          );
          id = yield createNewPortfolioSaga(defaultPortfolioName, userCurrency);
          yield put(fetchPortfolioList.trigger());
          yield put(removeSnackBar.trigger({ id: snackBarId }));
          yield put(
            addSnackBar.trigger({
              type: 'good',
              message: 'Portfolio successfully created',
              lifeTime: 2000,
            })
          );
        }
        yield put(
          updateUserProfile.trigger({
            settings: {
              defaultPortfolio: id,
            },
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchDashboardMyMarketsAndIndustriesWorker() {
  try {
    const caller = getAuthenticatedAhoy();
    const myMarketsAndIndustries: MyMarketsAndIndustriesResponse = yield caller(
      getDashboardMyMarketsAndIndustriesService
    );
    yield put(
      fetchDashboardMyMarketsAndIndustries.success({
        data: myMarketsAndIndustries.data,
      })
    );
  } catch (e: any) {
    yield put(
      fetchDashboardMyMarketsAndIndustries.failure({
        message: e.message || e.errors || 'Error fetching dashboard events',
      })
    );
  } finally {
    yield put(fetchDashboardMyMarketsAndIndustries.fulfill());
  }
}

function* watchSetDefaultPortfolioIdWorker() {
  yield takeLatest(fetchPortfolioList.SUCCESS, setDefaultPortfolioIdWorker);
}

function* watchFetchDashboardMyMarketsAndIndustriesWorker() {
  yield takeLatest(
    fetchDashboardMyMarketsAndIndustries.TRIGGER,
    fetchDashboardMyMarketsAndIndustriesWorker
  );
}

export default [
  watchSetDefaultPortfolioIdWorker,
  watchFetchDashboardMyMarketsAndIndustriesWorker,
];
